import Vue from 'vue'
import VueRouter from 'vue-router'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import setState from 'vue-setstate'
import store from '@/store'

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VModal, { componentName: "modal" });
Vue.use(VTooltip);
Vue.use(setState);

const router = new VueRouter({
  mode: 'history'
});

const config = {
  store,
  router
};

export default config;
